
import { Vue, Component, Model, Prop } from 'vue-property-decorator'
@Component({
  name: 'CommonPagination',
  components: {},
})
export default class CommonPagination extends Vue {
  @Prop({ default: 1 }) page!: number
  @Prop() total!: number
  @Prop({ default: 16 }) itemsPerPage!: number
  @Prop({ default: 8 }) totalVisible!: number

  get totalPages(): number {
    if (this.total && this.itemsPerPage && this.itemsPerPage !== 0)
      return Math.ceil(this.total / this.itemsPerPage)
    return 1
  }

  onInput(value: number): void {
    this.$emit('pageChanged', value)
  }
}
